import type { PdfConfig } from '../../../domain/types/configs/company/PdfConfig';

export const pdfConfig: PdfConfig = {
  tableColor: "#00416b",
  storagePath: "PROMED/company_logo/VML_110x100px-01.png",
  logo: "https://firebasestorage.googleapis.com/v0/b/dawipo-qa.appspot.com/o/PROMED%2Fcompany_logo%2FVML_110x100px-01.png?alt=media&token=b34092b6-0996-467a-9902-36016b9f4221",
  color: "#00416b"
}; 